namespace Matrix.Workflow {
    export interface ApprovalResponse extends Serenity.ServiceResponse {
    }
}
